import React from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Box,
    Link
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    warningIcon: {
        fontSize: '2rem',
        marginRight: theme.spacing(1),
        color: theme.palette.warning.main,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    bulletPoint: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
        '&::before': {
            content: '"•"',
            marginTop: '0.2em',
        },
    },
}));

function SaveWarningDialog({ open, onClose, translate, locale = 'en' }) {
    const classes = useStyles();

    // Map locale to contact page URL
    const contactUrls = {
        nl: 'https://www.amberscript.com/nl/contacteer-ons/',
        fr: 'https://www.amberscript.com/fr/contactez-nous/',
        de: 'https://www.amberscript.com/de/kontakt/',
        es: 'https://www.amberscript.com/es/contactenos/',
        it: 'https://www.amberscript.com/it/contatti/',
        pt: 'https://www.amberscript.com/en/contact-us/', // No Portuguese page, use English
        en: 'https://www.amberscript.com/en/contact-us/'
    };
    const contactUrl = contactUrls[locale] || contactUrls['en'];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="save-warning-dialog-title"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle id="save-warning-dialog-title">
                <Box display="flex" alignItems="center">
                    <span role="img" aria-label="warning" className={classes.warningIcon}>⚠️</span>
                    {translate('WARNING_ERRORS.saveWarningTitle')}
                </Box>
            </DialogTitle>
            <DialogContent>
                <DialogContentText className={classes.content}>
                    <div>{translate('WARNING_ERRORS.saveWarningBody')}</div>
                    
                    <div className={classes.bulletPoint}>
                        {translate('WARNING_ERRORS.saveWarningStep1')}
                    </div>
                    
                    <div className={classes.bulletPoint}>
                        {translate('WARNING_ERRORS.saveWarningStep2')}
                    </div>
                    
                    <div className={classes.bulletPoint}>
                        {translate('WARNING_ERRORS.saveWarningStep3')} {translate('WARNING_ERRORS.please')}<Link href={contactUrl} target="_blank" rel="noopener noreferrer">{translate('WARNING_ERRORS.contactUs')}</Link>.
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    I understand
                </Button>
            </DialogActions>
        </Dialog>
    );
}

SaveWarningDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default SaveWarningDialog; 